import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Shield, AlertTriangle, Ban, Eye, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const ChildSafetyPolicy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-4 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center gap-2 hover:bg-white/80"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('common.backToHome')}
        </Button>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-8 rounded-t-2xl">
            <div className="flex items-center gap-3 mb-4">
              <Shield className="h-10 w-10" />
              <h1 className="text-4xl font-bold">{t('legal.childSafetyPolicy.title')}</h1>
            </div>
            <p className="text-lg opacity-90">
              {t('legal.childSafetyPolicy.lastUpdated')}
            </p>
          </div>

          <div className="bg-white p-8 rounded-b-2xl shadow-lg">
            <div className="prose max-w-none">
              {/* Introduction */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <Shield className="h-6 w-6 text-blue-600" />
                  {t('legal.childSafetyPolicy.introduction.title')}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {t('legal.childSafetyPolicy.introduction.content')}
                </p>
              </section>

              {/* Prohibited Content */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <Ban className="h-6 w-6 text-red-600" />
                  {t('legal.childSafetyPolicy.prohibitedContent.title')}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {t('legal.childSafetyPolicy.prohibitedContent.content')}
                </p>
              </section>

              {/* User Reporting */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <AlertTriangle className="h-6 w-6 text-yellow-600" />
                  {t('legal.childSafetyPolicy.userReporting.title')}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {t('legal.childSafetyPolicy.userReporting.content')}
                </p>
              </section>

              {/* Account Termination */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <Ban className="h-6 w-6 text-red-600" />
                  {t('legal.childSafetyPolicy.accountTermination.title')}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {t('legal.childSafetyPolicy.accountTermination.content')}
                </p>
              </section>

              {/* Monitoring */}
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <Eye className="h-6 w-6 text-blue-600" />
                  {t('legal.childSafetyPolicy.monitoring.title')}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {t('legal.childSafetyPolicy.monitoring.content')}
                </p>
              </section>

              {/* Contact */}
              <section className="mb-8 bg-blue-50 p-6 rounded-xl">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <Mail className="h-6 w-6 text-blue-600" />
                  {t('legal.childSafetyPolicy.contact.title')}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {t('legal.childSafetyPolicy.contact.content')}
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChildSafetyPolicy;
